//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { IReportIssueDate } from './IReportIssueDate';
import { ReportType } from './Enums';

export class StudentTaxCreditReceiptReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportStudentIDsInputItem, IReportIssueDate {
    FormatForDuplexPrinting: boolean = false;
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    StudentIDs: string[] = [];
    IssueDate: string = "1970-01-01T00:00:00";
    IncludeChargesFromCalendarEventsOnly: boolean = false;
    override readonly Type: ReportType = ReportType.StudentTaxReceipt;

    constructor(initializer?: Partial<Omit<StudentTaxCreditReceiptReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentTaxCreditReceiptReportInputItem";
}
